import { ContentSection } from '../components/ContentSection';
import { FAQSectionHome } from '../components/FAQSection';
import { FeaturedWorkSection } from '../components/FeaturedWorkSection';
import { IntroSection } from '../components/IntroSection';
import { TechnologiesSection } from '../components/TechnologiesMarquee';

export const Home = () => {
  return (
    <div className="w-auto my-5">
      <IntroSection />
      <ContentSection />
      <TechnologiesSection />
      <FeaturedWorkSection />
      <FAQSectionHome />
    </div>
  );
};
